/* NP LAB mega menu hover — second tier on pointer, not click */
(() => {
  const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');

  function closeOthers(ul, keep) {
    ul.querySelectorAll(':scope > li details[open]').forEach((d) => {
      if (d !== keep) d.open = false;
    });
  }

  function bind() {
    if (!canHover.matches) return;
    document.querySelectorAll('.header__submenu.list-menu--disclosure').forEach((ul) => {
      if (ul.dataset.nplabHoverBound === '1') return;
      ul.dataset.nplabHoverBound = '1';
      ul.querySelectorAll(':scope > li').forEach((li) => {
        const details = li.querySelector(':scope details');
        if (!details) return;
        li.addEventListener('pointerenter', () => {
          closeOthers(ul, details);
          details.open = true;
        });
        li.addEventListener('pointerleave', () => {
          details.open = false;
        });
        const summary = details.querySelector('summary');
        if (summary) {
          summary.addEventListener('click', (e) => {
            if (e.target.closest('a') && e.target.closest('a') !== summary) return;
            e.preventDefault();
            details.open = li.matches(':hover');
          });
        }
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind);
  else bind();
  document.addEventListener('shopify:section:load', bind);
})();

/* NP LAB: set --mega-menu-rows for condensed column-major wrap */
(() => {
  function setCondensedRows() {
    document.querySelectorAll('.mega-menu__list--condensed').forEach((ul) => {
      const cols =
        parseInt(
          getComputedStyle(ul).getPropertyValue('--mega-menu-columns').trim(),
          10
        ) || 3;
      const n = ul.querySelectorAll(':scope > li').length;
      const rows = Math.max(1, Math.ceil(n / cols));
      ul.style.setProperty('--mega-menu-rows', String(rows));
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setCondensedRows);
  } else {
    setCondensedRows();
  }
  document.addEventListener('shopify:section:load', setCondensedRows);
})();

/* NP LAB: RF / nested mega-menu rows (column-major) */
(() => {
  function setRfRows() {
    document.querySelectorAll(
      '.mega-menu__list:has(#HeaderMenu-rf-spectrum-signal-analyzer), .mega-menu__list:has(#HeaderMenu-rf-accessories)'
    ).forEach((ul) => {
      /* Explicit CSS places Accessories on row 2–3; keep 3 rows */
      ul.style.setProperty('--mega-menu-rows', '3');
      ul.style.setProperty('--mega-menu-columns', '2');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setRfRows);
  else setRfRows();
  document.addEventListener('shopify:section:load', setRfRows);
})();
